module.exports = __webpack_public_path__ + "img/zhaohui.ab87a8bd.png";